<template>
  <div id="app" :class="{ 'mobile-app': isMobile, 'pc-app': isPC }">
    <!-- 动态头部组件 -->
    <PcHeader v-if="isPC" />
    <MobileHeader v-else />

    <keep-alive>
      <router-view />
    </keep-alive>

    <!-- 动态页脚组件 -->
    <PcFooter v-if="isPC" />
    <MobileFooter v-else />
  </div>
</template>

<script>
import { responsiveMixin } from "@/mixins/responsiveMixin";

// PC端组件
import PcHeader from "@/components/pc/header.vue";
import PcFooter from "@/components/pc/footer.vue";

// 移动端组件
import MobileHeader from "@/components/mobile/header.vue";
import MobileFooter from "@/components/mobile/footer.vue";

export default {
  name: "App",
  mixins: [responsiveMixin],
  components: {
    PcHeader,
    PcFooter,
    MobileHeader,
    MobileFooter,
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss"></style>
